export default[
	{
		name:'订单号',
		title:'订单号',
		hide:false
	},
	{
		name:'版本号',
		title:'版本号',
		hide:false
	},
	{
		name:'工厂号',
		title:'工厂号',
		hide:false
	},
	{
		name:'发出日期',
		title:'文件发出日期',
		hide:false
	}
]
export const detailHead=[
	{
		name:'序列号',
		title:'序列号',
		hide:false
	},
	{
		name:'文件发出时间',
		title:'文件发出时间',
		hide:false
	},
	{
		name:'供应商代码',
		title:'供应商代码',
		hide:false
	},
	{
		name:'供应商名称',
		title:'供应商名称',
		hide:false
	},
	{
		name:'供应商地址',
		title:'供应商地址',
		hide:false
	},
	{
		name:'客户代码',
		title:'客户代码',
		hide:false
	},
	{
		name:'客户名称',
		title:'客户名称',
		hide:false
	},
	{
		name:'客户地址',
		title:'客户地址',
		hide:false
	},
	{
		name:'发货方代码',
		title:'发货方代码',
		hide:false
	},
	{
		name:'发货方名',
		title:'发货方名',
		hide:false
	},{
		name:'发货方地址',
		title:'发货方地址',
		hide:false
	},{
		name:'发运方式',
		title:'发运方式',
		hide:false
	},{
		name:'宝马收货工厂代码',
		title:'宝马收货工厂代码',
		hide:false
	},{
		name:'到货工厂名称',
		title:'到货工厂名称',
		hide:false
	},{
		name:'到货工厂地址',
		title:'到货工厂地址',
		hide:false
	},{
		name:'到货地点代码',
		title:'到货地点代码',
		hide:false
	},{
		name:'仓库名称',
		title:'仓库名称',
		hide:false
	},{
		name:'零件最终消耗地点代码',
		title:'零件最终消耗地点代码',
		hide:false
	},{
		name:'宝马SAP工厂代码',
		title:'宝马SAP工厂代码',
		hide:false
	},{
		name:'零件号',
		title:'零件号',
		hide:false
	},{
		name:'供应商零件信息',
		title:'供应商零件信息',
		hide:false
	},{
		name:'工程变更号',
		title:'工程变更号	',
		hide:false
	},{
		name:'零件名称',
		title:'零件名称',
		hide:false
	},{
		name:'工程变更信息',
		title:'工程变更信息',
		hide:false
	},{
		name:'订单号',
		title:'订单号',
		hide:false
	},
	{
		name:'订单行号',
		title:'订单行号',
		hide:false
	},
	{
		name:'跟着零件编号',
		title:'跟着零件编号',
		hide:false
	},
	{
		name:'零件状态',
		title:'零件状态',
		hide:false
	},
	{
		name:'备注信息',
		title:'备注信息',
		hide:false
	},
	{
		name:'单位',
		title:'单位',
		hide:false
	},
	{
		name:'累计需求数量',
		title:'累计需求数量',
		hide:false
	},{
		name:'累计实际收到数量',
		title:'累计实际收到数量',
		hide:false
	},{
		name:'累计开始时间',
		title:'累计开始时间',
		hide:false
	},{
		name:'累计结束时间',
		title:'累计结束时间',
		hide:false
	},{
		name:'上一个ASN号',
		title:'上一个ASN号',
		hide:false
	},{
		name:'上一个ASN的数量',
		title:'上一个ASN的数量',
		hide:false
	},{
		name:'上一个ASN的日期',
		title:'上一个ASN的日期',
		hide:false
	},{
		name:'上一个需求编号',
		title:'上一个需求编号',
		hide:false
	},{
		name:'上一个需求的日期',
		title:'上一个需求的日期',
		hide:false
	},{
		name:'目前版本号',
		title:'目前版本号',
		hide:false
	},{
		name:'日期',
		title:'日期',
		hide:false
	},{
		name:'宝马联系人',
		title:'宝马联系人',
		hide:false
	},{
		name:'联系电话',
		title:'联系电话',
		hide:false
	},{
		name:'到货/需求日期',
		title:'到货/需求日期',
		hide:false
	},{
		name:'需求类型',
		title:'需求类型',
		hide:false
	},{
		name:'实际需求数量',
		title:'实际需求数量',
		hide:false
	},{
		name:'开始时间',
		title:'开始时间',
		hide:false
	},{
		name:'结束时间',
		title:'结束时间',
		hide:false
	},{
		name:'成品授权数量',
		title:'成品授权数量',
		hide:false
	},{
		name:'成品授权开始日期',
		title:'成品授权开始日期',
		hide:false
	},{
		name:'成品授权结束日期',
		title:'成品授权结束日期',
		hide:false
	},{
		name:'原材料备货数量',
		title:'原材料备货数量',
		hide:false
	},{
		name:'原材料备货开始日期',
		title:'原材料备货开始日期',
		hide:false
	},{
		name:'原材料备货结束日期',
		title:'原材料备货结束日期',
		hide:false
	},
]